<template>
  <svg class="_component-icon-svg" @click="$emit('click')" width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 3.5L4.66667 7L11 1" :style="componentStyle" stroke-width="2" />
  </svg>
</template>
<script>
/**
 * @module Ok 组件
 */
export default {
  name: 'Ok',
  /**
   * @prop {String} color 颜色
   */
  props: {
    color: {
      type: String,
      default: '#fff'
    }
  },
  /**
   * @member {Object} componentStyle 组件style
   */
  computed: {
    componentStyle() {
      return {
        stroke: this.color
      };
    },
    strokeColor() {
      return this.color === 'none' ? '#494A4D' : this.color;
    }
  }
};
</script>
<!-- <style lang="less" scoped src="./index.less"></style> -->
